// ** Third Party Components
import { AlertTriangle} from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

const NavbarSupport = () => {

  function displayHelp() {
    const myUserData = JSON.parse(localStorage.getItem('userData'))
    const myClient = JSON.parse(localStorage.getItem('client'))

    const language = myUserData.language.slice(0, -3)
    const clienvid = myUserData.clienvid
    const email = myUserData.email 
    const clientName = myClient.name
    const userId = myUserData.id
    const env = myUserData.envname

//    const myUserData = JSON.parse(localStorage.getItem('userData'))
//    const url = myUserData.url
    window.open(`https://support.optimahr.app?lang=${language}&userid=${userId}&email=${email}&clientname=${clientName}&env=${env}&clienvid=${clienvid}`, '_blank')
//    window.open(`https://${url}.optimahr.app/ticket`, '_blank')
//    window.open(`http://${url}.localhost:3000/ticket`, '_blank')
}

  return (
    <UncontrolledDropdown tag='li' className='dropdown-config nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-config-link' onClick={e => e.preventDefault()}>
        <AlertTriangle className='ficon' onClick={() => displayHelp()} />
      </DropdownToggle>
    </UncontrolledDropdown>
  )
}

export default NavbarSupport
